import { h } from 'preact';
import { GeoPath } from 'd3';
import PureComponent from './PureComponent';
import { Feature } from 'geojson';

class Places extends PureComponent<{ geoPath: GeoPath; places: Feature[] }> {
  render() {
    const { geoPath, places } = this.props;

    return (
      <g class="places">
        <g class="place-background-labels">
          {places.map((place, idx) => (
            <text
              key={`bg-${idx}`}
              class="place-background-label"
              transform={`translate(${geoPath.centroid(place)})`}
              dx={place.properties.dx}
              dy={place.properties.dy}
              text-anchor={place.properties.anchor}
            >
              {place.properties.name}
            </text>
          ))}
        </g>
        <g class="place-labels">
          {places.map((place, idx) => (
            <text
              key={`fg-${idx}`}
              class="place-label"
              transform={`translate(${geoPath.centroid(place)})`}
              dx={place.properties.dx}
              dy={place.properties.dy}
              text-anchor={place.properties.anchor}
            >
              {place.properties.name}
            </text>
          ))}
        </g>
      </g>
    );
  }
}

export default Places;
